import Hero from "components/aioptout/hero";
import OptOutInfo from "src/components/aioptout/optoutinfo";
import NewsLetter from "src/components/aioptout/newsletter";

const Features = () => {
  return (
    <>
      <Hero />
      <OptOutInfo />
      <NewsLetter />
      <div className="mt-20" />
    </>
  );
};

export default Features;
